import type { PartnerResponseDto } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import { PartnerAvailabilityTab } from "Partner/Pages/Detail/Tabs/PartnerAvailabilityTab";
import { PartnerBalanceTab } from "Partner/Pages/Detail/Tabs/PartnerBalanceTab";
import { PartnerDetailTab } from "Partner/Pages/Detail/Tabs/PartnerDetailTab";
import { PartnerEditTab } from "Partner/Pages/Detail/Tabs/PartnerEditTab";
import { PartnerInvoiceTab } from "Partner/Pages/Detail/Tabs/PartnerInvoiceTab";
import { PartnerOrdersTab } from "Partner/Pages/Detail/Tabs/PartnerOrdersTab";
import { PartnerPaths } from "Partner/Routes/Routing";
import type { TabType } from "Shared/Components/Tabs/Types/TabType";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";

export enum PartnerDetailTabs {
	detail = "detail",
	orders = "orders",
	balance = "balance",
	edit = "edit",
	invoice = "invoice",
	availability = "availability",
}

const partnerTabResource = Resources.base.partner.tabs;

export const getPartnerDetailTabs = (
	partnerId: number,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
): TabType[] => [
	{
		index: PartnerDetailTabs.detail,
		label: t(partnerTabResource.detail),
		path: PartnerPaths.Detail.path(partnerId),
		tab: (partner: PartnerResponseDto) =>
			partner && <PartnerDetailTab partner={partner} />,
	},
	{
		index: PartnerDetailTabs.edit,
		label: t(partnerTabResource.edit),
		path: PartnerPaths.Edit.path(partnerId),
		tab: (partner: PartnerResponseDto) =>
			partner && <PartnerEditTab partner={partner} />,
	},
	{
		index: PartnerDetailTabs.orders,
		label: t(partnerTabResource.orders),
		path: PartnerPaths.Orders.path(partnerId),
		tab: (partner: PartnerResponseDto) =>
			partner && <PartnerOrdersTab partnerId={partner.partner.id} />,
	},
	{
		index: PartnerDetailTabs.balance,
		label: t(partnerTabResource.balance),
		path: PartnerPaths.Balance.path(partnerId),
		tab: <PartnerBalanceTab partnerId={partnerId} />,
	},
	{
		index: PartnerDetailTabs.invoice,
		label: t(partnerTabResource.invoices),
		path: PartnerPaths.Invoice.path(partnerId),
		tab: <PartnerInvoiceTab partnerId={partnerId} />,
	},
	{
		index: PartnerDetailTabs.availability,
		label: t(partnerTabResource.availability),
		path: PartnerPaths.Availability.path(partnerId),
		tab: <PartnerAvailabilityTab partnerId={partnerId} />,
	},
];
